/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../workflow/ui_elements/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "printable_check": {
                "nested": {
                  "PrintableCheckLogEvents": {
                    "nested": {
                      "Entry": {
                        "fields": {
                          "viewLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Education": {
                        "fields": {
                          "viewLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickContinueLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          },
                          "clickDoNotShowAgainLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Write": {
                        "fields": {
                          "viewLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickContinueLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Success": {
                        "fields": {
                          "viewLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickPrintLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          },
                          "clickDownloadLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "Management": {
                        "fields": {
                          "viewLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 1,
                            "rule": "optional"
                          },
                          "clickDuplicateLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 2,
                            "rule": "optional"
                          },
                          "clickPrintLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 3,
                            "rule": "optional"
                          },
                          "clickDownloadLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 4,
                            "rule": "optional"
                          },
                          "clickCancelLogEvent": {
                            "type": "squareup.bbfrontend.service.v1.LogEvent",
                            "id": 5,
                            "rule": "optional"
                          },
                          "cancellationConfirmationLogEvents": {
                            "type": "squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Management.CancellationConfirmation",
                            "id": 6,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CancellationConfirmation": {
                            "fields": {
                              "viewLogEvent": {
                                "type": "squareup.bbfrontend.service.v1.LogEvent",
                                "id": 1,
                                "rule": "optional"
                              },
                              "clickConfirmLogEvent": {
                                "type": "squareup.bbfrontend.service.v1.LogEvent",
                                "id": 2,
                                "rule": "optional"
                              },
                              "clickDoNothingLogEvent": {
                                "type": "squareup.bbfrontend.service.v1.LogEvent",
                                "id": 3,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckLogEvents?.nested?.Entry && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckLogEvents?.nested?.Education && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckLogEvents?.nested?.Write && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckLogEvents?.nested?.Success && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckLogEvents?.nested?.Management && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.printable_check?.nested?.PrintableCheckLogEvents?.nested?.Management?.nested?.CancellationConfirmation) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PrintableCheckLogEvents @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 11:1
 */
export const PrintableCheckLogEvents = {};
/**
 * Log events for the write check entry point.
 *
 * SOURCE Entry @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 13:3
 */
PrintableCheckLogEvents.Entry = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Entry');
fixType(PrintableCheckLogEvents.Entry);
Builder.createAndAttachToType(PrintableCheckLogEvents.Entry);
/**
 * Log events for the write check education.
 *
 * SOURCE Education @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 19:3
 */
PrintableCheckLogEvents.Education = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Education');
fixType(PrintableCheckLogEvents.Education);
Builder.createAndAttachToType(PrintableCheckLogEvents.Education);
/**
 * Log events for writing a printable check.
 *
 * SOURCE Write @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 26:3
 */
PrintableCheckLogEvents.Write = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Write');
fixType(PrintableCheckLogEvents.Write);
Builder.createAndAttachToType(PrintableCheckLogEvents.Write);
/**
 * Log events for successfully written check.
 *
 * SOURCE Success @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 32:3
 */
PrintableCheckLogEvents.Success = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Success');
fixType(PrintableCheckLogEvents.Success);
Builder.createAndAttachToType(PrintableCheckLogEvents.Success);
/**
 * Log events for managing a written check in unified activity.
 *
 * SOURCE Management @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 39:3
 */
PrintableCheckLogEvents.Management = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Management');
fixType(PrintableCheckLogEvents.Management);
Builder.createAndAttachToType(PrintableCheckLogEvents.Management);
/**
 * SOURCE CancellationConfirmation @ squareup/bbfrontend/common/printable_check/printable_check_log_events.proto at 47:5
 */
PrintableCheckLogEvents.Management.CancellationConfirmation = $root.lookupType('squareup.bbfrontend.common.printable_check.PrintableCheckLogEvents.Management.CancellationConfirmation');
fixType(PrintableCheckLogEvents.Management.CancellationConfirmation);
Builder.createAndAttachToType(PrintableCheckLogEvents.Management.CancellationConfirmation);